import React  from 'react';
import ReactDom  from 'react-dom';

import { App } from '../src/Components/App'; 
import 'bootstrap/dist/css/bootstrap.css';

ReactDom.render(<App />,document.getElementById('root'));

  
 